import { FC } from 'react';

import { IconPreloaded } from './Icon';
import { SvgIcon } from './SvgIcon.type';
import { SvgPreloadedIcon } from './SvgPreloadedIcon';

export const IconCaretRightPreloaded = () => (
  <SvgPreloadedIcon name="caret-right" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9 5.151 6.425 6.425a.6.6 0 0 1 0 .848l-6.424 6.424L8.152 18l6-6-6-6 .849-.849Z"
    />
  </SvgPreloadedIcon>
);

export const IconCaretRight: FC<SvgIcon> = (props) => (
  <IconPreloaded {...props} viewBox="0 0 24 24" name="caret-right" />
);
